/**
 *    (c) 2009-2014 Demandware Inc.
 *    Subject to standard usage terms and conditions
 *    For all details and documentation:
 *    https://bitbucket.com/demandware/sitegenesis
 */

'use strict';

const SitePreferences = window.SitePreferences || {};
const Resources = window.Resources || {};

// responsiveImage is module maintained by DAM team. The next two lines are enough to init dam images and videos loading. Do not remove these lines!
const responsiveImage = require('./dam/responsive_image'); /* eslint-disable-line no-unused-vars */
const damResponsiveVideo = require('./dam/responsive_video'); /* eslint-disable-line no-unused-vars */
const headermenu = require('./header-menu'),
    headerNavigation = require('./navigation'),
    headerCheckout = require('./components/checkout/header/header'),
    countries = require('./countries'),
    productBackButton = require('./productBackButton'),
    google = require('./modules/google'),
    flyout = require('./flyout'),
    minicart = require('./minicart'),
    page = require('./page'),
    rating = require('./rating'),
    tooltip = require('./tooltip'),
    validator = require('./validator'),
    tls = require('./tls'),
    categoryRefinements = require('./category-refinements'),
    ritualsStyles = require('./rituals-styles'),
    responsiveBg = require('./responsive-background'),
    slickSlider = require('./slick-slider'),
    grid = require('./grid'),
    customSelect = require('./select-custom'),
    gst = require('./gst'),
    variant = require('./pages/product/variant'),
    option = require('./pages/product/option'),
    addToCart = require('./pages/product/addToCart'),
    video = require('./video'),
    responsiveVideo = require('./responsive-video'),
    seoText = require('./seo-text'),
    tabs = require('./tabs'),
    backToTop = require('./backtotop'),
    accordion = require('./accordion'),
    advent = require('./advent'),
    whitelist = require('./whitelist'),
    productSlider = require('./product-slider'),
    productFilter = require('./product-filter'),
    productDescription = require('./product-description'),
    scrollAnimation = require('./scrollAnimation'),
    animeBlock = require('./anim-block'),
    toaster = require('./toaster'),
    sectionScroller = require('./sectionScroller'),
    dragList = require('./dragList'),
    productTile = require('./product-tile'),
    footer = require('./footer'),
    productConfiguratorApp = require('./components/product-configurator/product-configurator-app'),
    productConfiguratorInlineApp = require('./components/product-configurator-inline/product-configurator-inline-app'),
    checkoutApp = require('./components/checkout/checkout-app'),
    vueFormApp = require('./components/vue-form/vue-form-app'),
    dynamicFormApp = require('./components/dynamic-form/dynamic-form-app'),
    modalApp = require('./components/modal/modal-app'),
    flyinApp = require('./components/flyin/flyin-app'),
    adventReveal = require('./adventReveal'),
    productExperience = require('./productExperience'),
    leadtime = require('./leadtime'),
    horizontalProductScroll = require('./horizontal-product-scroll'),
    giftsetZoom = require('./giftsetImageZoom'),
    giftReveal = require('./gift-reveal'),
    socialCommerce = require('./social-commerce/social-commerce'),
    collectionIngredients = require('./pages/collection/collection-ingredients'),
    easter = require('./easter/easter'),
    animatedCounter = require('./animated-counter'),
    adventMovingTitle = require('./advent-moving-title'),
    adventTextAnimation = require('./advent-text'),
    bannerSrcHandler = require('./banner-src-handler'),
    stickyAddToCart = require('../js/pages/product/stickyaddtocart'),
    crm23 = require('./crm2_3'),
    genericNavAccordion = require('./generic-nav-accordion'),
    fastlyGeolocation = require('./fastlyGeolocation'),
    dataDogRum = require('./data-dog-rum'),
    dataDogLogs = require('./data-dog-logs'),
    converterBgnEur = require('./price-converter-bg'),
    oneTrustBannerObserver = require('./onetrust-banner-observer');

const helper = {
    debounce: require('./modules/helpers/debounce'),
    isKeyCodeNumber: require('./modules/helpers/isKeyCodeNumber'),
    cookiesAccepted: require('./modules/helpers/cookiesAccepted')
};

const util = {
    isMobile: require('./modules/util/isMobile'),
    isMobileOrTabletWidth: require('./modules/util/isMobileOrTabletWidth'),
    getQueryStringParams: require('./modules/util/getQueryStringParams'),
    getTriggerFromHash: require('./modules/util/getTriggerFromHash'),
    limitCharacters: require('./modules/util/limitCharacters')
};

function initializeEvents() {
    const controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

    // accessibility - focus the first element on page, so the user can tab through without first clicking on the page
    if (!util.isMobile()) {
        $('.js-skip-to-content').focus();
    }

    $('body')
        .on('keydown', 'textarea[data-character-limit]', function (e) {
            const text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length;

            if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
                e.preventDefault();
            }
        })
        .on('change keyup mouseup', 'textarea[data-character-limit]', function () {
            const text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length;
            let charsRemain = charsLimit - charsUsed;

            if (charsRemain < 0) {
                $(this).val(text.slice(0, charsRemain));
                charsRemain = 0;
            }

            $(this).next('div.char-count').find('.char-remain-count').html(charsRemain);
        });

    // add show/hide navigation elements
    $('.secondary-navigation .toggle').click(function () {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    // add generic toggle functionality
    $('.toggle').next('.toggle-content').hide();
    $('.toggle').click(function () {
        $(this).toggleClass('expanded').next('.toggle-content').toggle();
    });

    // preventing anything except numbers to insert into min/max price input fields
    $(document).on('keypress input copy', '.js-min-price, .js-max-price, .js-price-filter-min, .js-price-filter-max', function (e) {
        const charCode = (e.which) ? e.which : e.keyCode;
        return helper.isKeyCodeNumber(charCode);
    });

    // subscribe email box
    const $subscribeEmail = $('.subscribe-email');
    if ($subscribeEmail.length > 0) {
        $subscribeEmail.focus(function () {
            const val = $(this.val());
            if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                return; // do not animate when contains non-default value
            }

            $(this).animate({color: '#999999'}, 500, 'linear', function () {
                $(this).val('').css('color', '#333333');
            });
        }).blur(function () {
            const val = $.trim($(this.val()));
            if (val.length > 0) {
                return; // do not animate when contains value
            }
            $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
                .css('color', '#999999')
                .animate({color: '#333333'}, 500, 'linear');
        });
    }

    // scroll to top button
    $('.js-scrolltotop').on('click', function(){
        $('html, body').animate({scrollTop: $('body').offset().top}, 800);
    });

    // show welcome message
    const gwpWelcomeBanner = $('.js-gwp-welcome-overlay');
    const showWelcomeToast = util.isMobile() && gwpWelcomeBanner.length > 0 && !gwpWelcomeBanner.hasClass('hide');

    if (showWelcomeToast) {
        toaster.load({
            url: Urls.getGwpWelcomeToastMessage + '?currentPipeline=' + Urls.currentPipeline
        });
    }

    // if it is a linked block, go to href on click
    $(document).on('click keydown', '.js-linked-block', function(e){
        const href = $(this).data('href');

        if ((e.type == 'keydown' && e.which == '13') || e.type == 'click') {
            window.location.href = href;
        }
    });

    //custom styling for checkboxes
    if ($('.js-form').length) {
        $('.js-form').find('.label-inline').each(function () {
            const $inputChecked = $(this).find('input:checked');
            const $label = $(this).find('label');

            if ($inputChecked.length) {
                $(this).find('label').addClass('checked');
            }

            $label.each(function () {
                $(this).on('click', function () {
                    $(this).closest('.label-inline').find('input').on('change', function () {
                        if ($(this).is(':checked')) {
                            $(this).closest('.label-inline').find('label').addClass('checked');
                        } else {
                            $(this).closest('.label-inline').find('label').removeClass('checked');
                        }
                    });
                });
            });
        });

    }

    $(document).on('click', '.js-checkout-opening-hours-button', function () {
        const $this = $(this);

        $this.toggleClass('open');
        $this.next('.js-checkout-opening-hours-list').stop().slideToggle();
    });

    toggleReadMore('.js-discover-toggle', '.js-discover-short', '.js-discover-long');
    toggleReadMore('.js-cop-desc-toggle', '.js-cop-short-desc', '.js-cop-long-desc');

    stickyCheckoutBar();

    if ($('.js-animated-banner').length && !$('.js-animated-banner').closest('.js-encode').length) {
        animateVideoBannerElements();
    }

    $(window).scroll(function() {
        stickyCheckoutBar();
    });

}

function stickyCheckoutBar() {
    if ($('.js-checkout-sticky-bar').length) {
        const scroll = $(window).scrollTop();
        let $mainBtn;

        if ($('.pt_cart').length) {
            $mainBtn = $('.pt_cart .cart-actions .btn--submit');
        } else if ($('.pt_checkout').length) {
            $mainBtn = $('.pt_checkout .js-checkout-step-content:visible .btn-submit');
        }

        if ($mainBtn.length > 0) {
            const mainBtnOffset = $mainBtn.offset().top;
            const mainBtnHeight = $mainBtn.outerHeight();

            if (scroll > mainBtnOffset + mainBtnHeight || scroll + $(window).height() < mainBtnOffset){
                $('.js-checkout-sticky-bar').addClass('show-bar');
                $('.sticky-bar-spacer').addClass('show-bar');
            } else {
                $('.js-checkout-sticky-bar').removeClass('show-bar');
                $('.sticky-bar-spacer').removeClass('show-bar');
            }
        }
    }
}

function toggleReadMore(el, shortText, longText) {
    $(el).on('click', function () {
        const $this = $(this);
        const $shortText = $this.siblings(shortText);
        const $longText = $this.siblings(longText);

        if (!$this.hasClass('open')) {
            $this.addClass('open');
            $shortText.hide();
            $longText.show();
        } else {
            $this.removeClass('open');
            $longText.hide();
            $shortText.show();
        }
    });
}

function animateVideoBannerElements() {
    $('.fade-in-element').each(function(i, element) {
        setTimeout(function() {
            $(element).addClass('visible');
        }, i * 800);
    });
}

/**
 * @private
 * @function
 * @description Checks and gets the anchor id from the url and scrolls to that block
 */
function initPageAnchors(){
    $(document).on('click','[data-jump-to]', function(e){
        e.preventDefault();
        ritualsStyles.jumpToAnchor($(this).data('jump-to'));
    });
}

function scrollToAnchor() {
    const param = util.getQueryStringParams(window.location.href).jumpto;
    let hash = util.getTriggerFromHash();

    if (!param && hash.length === 0) {
        return;
    }
    hash = hash.includes('?') ? hash.split('?')[0] : hash;
    const scrollTarget = param || hash;
    const scrollTargetEl = document.querySelector('[data-anchor-id="' + scrollTarget + '"]');
    const targetShouldLazyLoad = scrollTargetEl ? scrollTargetEl.hasAttribute('data-anchor-islazyloaded') : false;

    if (targetShouldLazyLoad) {
        document.dispatchEvent(new CustomEvent('shouldTriggerLazyload', {detail: scrollTarget}));
    }

    //open appropriate accordion tab
    if ($('.experience-assets-navigationtitle').length) {
        scrollTargetEl.closest('.experience-assets-navigationtitle').querySelector('li .js-generic-nav-button').click();
    }

    setTimeout(() => {
        ritualsStyles.jumpToAnchor(scrollTarget);
    }, 1000);
}

function expandAccordionBasedOnAnchor() {
    const anchorId = util.getQueryStringParams(window.location.href).jumpto;
    const element = $('[data-anchor-id=' + anchorId + ']');
    $(element).addClass('open-acc').attr('aria-expanded', true);
    $(element).parent().find('.faq-accordion-content').attr('aria-hidden', false).show();
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }
    // load js specific styles
    util.limitCharacters();
}

const pages = {
    account: require('./pages/account'),
    cart: require('./pages/cart'),
    compare: require('./pages/compare'),
    product: require('./pages/product'),
    collection: require('./pages/collection'),
    registry: require('./pages/registry'),
    search: require('./pages/search'),
    wishlist: require('./pages/wishlist'),
    storelocator: require('./pages/storelocator'),
    singlepagecheckout: require('./pages/checkout/singlepagecheckout'),
    checkout: require('./pages/checkout/checkoutlogin'),
    orderconfirmation: require('./pages/checkout/orderconfirmation'),
    faq: require('./pages/faq'),
    jobs: require('./pages/jobs'),
    mag: require('./pages/magazine'),
    customerservice: require('./customerservice'),
    newsletter: require('./newsletter'),
    promotions: require('./pages/promotions'),
    customerbarcode: require('./pages/customerbarcode'),
    giftcard: require('./pages/giftcard'),
    outlet: require('./pages/outlet'),
    hairtemple: require('./pages/hairtemple-landing'),
    registration: require('./pages/registration'),
    whereIsMyOrder: require('./pages/whereIsMyOrder/whereIsMyOrder'),
    faqredesign: require('./pages/faqredesign')
};

const app = {
    init: function () {
        if (document.cookie.length === 0) {
            $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }

        initializeDom();
        initializeEvents();
        dataDogRum.init();
        dataDogLogs.init();

        // Modal and Flyin needs to init first so we know the vue stuff is in place
        modalApp.init();
        flyinApp.init();

        // init specific global components
        ritualsStyles.initInputStyles();
        headermenu.init();
        headerNavigation.init();
        headerCheckout.init();
        tooltip.init();
        flyout.init();
        minicart.init();
        validator.init();
        rating.init();
        categoryRefinements.init();
        productDescription.init();
        addToCart.init();
        variant();
        option();
        video.initGeneric();
        responsiveVideo.init();
        leadtime.init();
        giftReveal.init();
        socialCommerce.init();
        easter.init();
        animatedCounter.init();
        adventMovingTitle.init();
        fastlyGeolocation.init();
        converterBgnEur.init();
        oneTrustBannerObserver.init();

        if ($('.order-confirmation-summary').length) {
            $('.refill-container').hide();
        }

        if ($('.js-product-container-giftset').length > 0) {
            giftsetZoom.init();
        }

        if ($('.js-advent-block').length > 0) {
            advent.init();
        }
        if ($('.js-b2b-signup-form').length > 0) {
            whitelist.init();
        }
        if ($('.js-advent-split').length > 0) {
            adventTextAnimation.init();
        }

        if ($('.js-product-slider-steps').length > 0) {
            productSlider.init();
        }

        if ($('.js-product-filter-block').length > 0) {
            productFilter.init();
        }

        if ($('.product-list-slider-block').length > 0) {
            productTile.init();
        }

        if ($('.js-banner').length > 0) {
            bannerSrcHandler.init();
        }

        if ($('.js-onboarding-page').length > 0){
            stickyAddToCart.init();
        }

        if ($('.js-crm-page').length > 0) {
            crm23.init();
        }

        if ($('.phase-section-wrapper').length > 0) {
            pages.cart.init();
        }

        if ($('.js-generic-nav-acc').length || $('.js-generic-acc-wrapper').length || $('.js-footer-middle-elements').length) {
            genericNavAccordion.init();
        }

        // execute page specific initializations
        $.extend(page, window.pageContext);
        const ns = page.ns;
        if (ns && pages[ns] && pages[ns].init) {
            pages[ns].init();
        }


        // do not init these in the styleguide (sg)
        if (ns !== 'sg') {
            ritualsStyles.initLazyLoad();
            ritualsStyles.prepareAnimBlocks();
            customSelect.init();
            seoText.init();
            tabs.init();
            backToTop.init();
            accordion.init();
            responsiveBg.init();
            google.places.init();
            google.tagManager.init();
            animeBlock.init();
            sectionScroller.init();
            scrollAnimation.init();
            slickSlider.init();
            horizontalProductScroll.init();

            if ($('.js-concept-highlight-block').length) {
                ritualsStyles.initConceptHighlightHeight();
            }
        }

        // On these pages there's a simple footer without country selector
        if (ns !== 'singlepagecheckout' && ns !== 'checkout' && ns !== 'sg') {
            countries.init();
        }

        if (ns === 'content'){
            pages.customerbarcode.init({format: 'ean13', fontSize: 0, margin: 0, height: 28});
        }

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }

        // init Guided Selling Tool js if is exists in the page
        if ($('.js-gst-wrapper').length > 0 && ns !== 'sg'){
            gst.init();
        }

        // TODO: Find a better location for this.
        // Ticket: https://rituals.atlassian.net/browse/DL-22464
        collectionIngredients.init();

        productBackButton.init();

        fadeIngredientsBlock();
        initPageAnchors();
        footer.init();

        // DL-16302: removed "javascript:;"" from href attributes, here we prevent refreshing a page on click
        $('a[href=""]').on('click', function (e) {
            e.preventDefault();
        });

        if ($('.js-show-switch-session-modal') && $('.js-show-switch-session-modal').length) {
            socialCommerce.showSwitchSessionModal();
        }
    }
};

function fadeIngredientsBlock() {
    if ($('.js-collection-ingredients').length) {
        const offset = $(window).height() / 2;
        const $colsHolder = $('.js-collection-ingredients');
        const $leftCol = $('.js-collection-ingredient-col:first-child');
        const $rightCol = $('.js-collection-ingredient-col:last-child');
        const colsRect = $colsHolder[0].getBoundingClientRect().top;

        if (colsRect < offset) {
            $leftCol.addClass('col-fadein');
            setTimeout(function () {
                $rightCol.addClass('col-fadein');
            }, 1000);
        }
    }
}

function showStickyTopMessage() {
    const $stickyBar = $('.js-sticky-top-message-bar');
    const stickyBarHeight = $stickyBar.outerHeight();

    $('.js-sticky-top-message-placeholder').css('height', stickyBarHeight);

    setTimeout(function () {
        $stickyBar.addClass('loaded');
        initStickyTopMessage();
    }, 1000);
}

function initStickyTopMessage() {
    const $stickyBar = $('.js-sticky-top-message-bar.loaded');
    const $stickyBarHolder = $('.js-sticky-top-message-placeholder');
    const stickyBarHolderRect = $stickyBarHolder[0].getBoundingClientRect().top;

    if (stickyBarHolderRect <= 0) {
        $stickyBar.addClass('sticky');
        $stickyBarHolder.addClass('in-place');
    } else {
        $stickyBar.removeClass('sticky');
        $stickyBarHolder.removeClass('in-place');
    }
}

// general extension functions
(function () {
    String.format = function () {
        let s = arguments[0];
        const len = arguments.length - 1;
        for (let i = 0; i < len; i++) {
            const reg = new RegExp('\\{' + i + '\\}', 'gm');
            s = s.replace(reg, arguments[i + 1]);
        }
        return s;
    };
})();

// initialize app
$(document).ready(function () {
    app.init();
});

$(window).on('load', function () {
    grid.init();

    scrollToAnchor();
    expandAccordionBasedOnAnchor();

    // do not init these in the styleguide (sg)
    if (page.ns !== 'sg') {
        dragList.init();
        adventReveal.init();
        productExperience.init();
    }
    checkoutApp.init();
    vueFormApp.init();
    dynamicFormApp.init();
    pages.product.initOnDomReady();
    productConfiguratorApp.init();
    productConfiguratorInlineApp.init();

    if (helper.cookiesAccepted()) {
        video.initGeneric();
    }

    if (!util.isMobile()) {
        ritualsStyles.initCustomScrollbar();
    }

    if (util.isMobileOrTabletWidth()) {
        minicart.initMobileConfirmation();
    }

    //To prevent the element visibilty while the page is loading we
    //initially set the opacity 0. We set it to 1 by adding this class on page load.
    $('.js-toaster-container, .js-reset-password-confirmation, .js-new-password-confirmation').addClass('page-loaded');

    if ($('.js-page-fullheight').length && !util.isMobileOrTabletWidth()) {
        ritualsStyles.initBottomFooterPosition();
    }

    if ($('.js-sticky-top-message-bar').length) {
        showStickyTopMessage();
    }
});

$(window).on('resize', helper.debounce(function() {
    if ($('.js-page-fullheight').length && !util.isMobileOrTabletWidth()) {
        ritualsStyles.initBottomFooterPosition();
    }

    if ($('.js-concept-highlight-block').length && !util.isMobile()) {
        ritualsStyles.initConceptHighlightHeight();
    }
}, 200));

$(window).on('scroll', function () {
    fadeIngredientsBlock();

    if ($('.js-sticky-top-message-bar').length) {
        initStickyTopMessage();
    }
});
